import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Navbar from "@/components/Navbar";
import HeroSection from "@/components/HeroSection";
import InteractiveSlider from "@/components/InteractiveSlider";
import Curriculum from "@/components/Curriculum";
import OfferCard from "@/components/OfferCard";
import Gallery from "@/components/Gallery";
import FAQ from "@/components/FAQ";
import Footer from "@/components/Footer";

const LandingPage = () => {
  return (
    <div data-testid="landing-page" className="min-h-screen bg-black">
      <Navbar />
      <HeroSection />
      <InteractiveSlider />
      <Curriculum />
      <OfferCard />
      <Gallery />
      <FAQ />
      <Footer />
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
